import { isPos, isSignage, signageRoot } from 'src/config'

export default ({ router }) => {
  if (!isSignage && !isPos) return

  /**
   * Set routes
   */
  const routeData = {
    path: signageRoot,
    component: () => import('src/modules/signage/layouts/SignLayout.vue'),
    meta: { auth: false }
  }
  routeData.children = [
    {
      name: 'signage:screen',
      path: 'screen/:screenId',
      component: () => import('src/modules/signage/Screen')
    },
    {
      name: 'signage:screen-landscape',
      path: 'screen-landscape/:screenId',
      component: () => import('src/modules/signage/ScreenLandscape')
    },
    {
      name: 'signage:screen-landscape-poster-left',
      path: 'screen-landscape-poster-left/:screenId',
      component: () => import('src/modules/signage/ScreenLandscapePosterLeft')
    },
    {
      name: 'signage:screen-portrait',
      path: 'screen-portrait/:screenId',
      component: () => import('src/modules/signage/ScreenPortrait')
    },
    {
      name: 'signage:screen-portrait-status-stream',
      path: 'screen-portrait-status-stream/:screenId',
      component: () => import('src/modules/signage/ScreenPortraitStatusStream')
    },
    {
      name: 'signage:site',
      path: 'site/:siteId',
      component: () => import('src/modules/signage/Site')
    },
    {
      name: 'signage:site2',
      path: 'site2/:siteId',
      component: () => import('src/modules/signage/Site2')
    },
    {
      name: 'signage:site-portrait',
      path: 'site-portrait/:siteId',
      component: () => import('src/modules/signage/SitePortrait')
    },
    {
      name: 'signage:showings-banner',
      path: 'showings-banner/:siteId',
      component: () => import('src/modules/signage/ShowingsBanner')
    },
    {
      name: 'signage:showings-poster',
      path: 'showings-poster/:siteId',
      component: () => import('src/modules/signage/ShowingsPoster')
    },
    {
      name: 'signage:showings-list',
      path: 'showings-list/:siteId',
      component: () => import('src/modules/signage/ShowingsList')
    },
    {
      name: 'signage:media',
      path: 'media/:siteId',
      component: () => import('src/modules/signage/Media')
    },
    {
      name: 'signage:combined-screens',
      path: 'combined-screens',
      component: () => import('src/modules/signage/CombinedScreens')
    }
  ]

  router.addRoute(routeData)
}
